import TimeKeeper from "react-timekeeper";
import { useState, useEffect, useRef } from "react";
import "./Timepicker.css";
import moment from "moment";

export default function Timepicker({ time, callback, placeholder, label, isDisabled = false, required = false }) {
  const [selectTime, setSelectedTime] = useState(null);
  const [selectTimeLabel, setSelectedTimeLabel] = useState('');
  const [show, setShow] = useState(false);
  const timePickerRef = useRef(null); // Reference to the TimePicker component

  const setTime = (val) => {
    if (callback !== undefined) {
      callback(val.formatted24);
      setSelectedTimeLabel(val.formatted12);
    }
  };

  useEffect(() => {
    if (time && time.length) {
      const formattedTime = moment(time, 'HH:mm:ss').format('hh:mmA');
      const formattedTimeLabel = moment(time, 'HH:mm:ss').format('hh:mm A');
      setSelectedTime(formattedTime);
      setSelectedTimeLabel(formattedTimeLabel);
    }
  }, [time]);

  // Add click event listener to close the TimePicker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (timePickerRef.current && !timePickerRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="time-picker" ref={timePickerRef}>
      <label>{label || "Select Timing"}{required ? <sup>*</sup> : ''}</label>
      <input
        type="text"
        placeholder={placeholder || 'Select Time'}
        disabled={isDisabled}
        onChange={() => {}}
        onKeyDown={(e) => e.preventDefault()}
        value={selectTimeLabel}
        onFocus={() => setShow(true)}
      />
      {show && !isDisabled && (
        <>
          <div className="over-lay"></div>
          <div className="time-picker-content">
            <TimeKeeper
              time={selectTime}
              doneButton={(times) => (
                <div className="modal-footer">
                  <button
                    type='button'
                    className='white-btn btn'
                    onClick={() => setShow(false)}
                  >
                    Close
                  </button>
                  <button
                    type='button'
                    className='primary-btn'
                    onClick={() => {
                      setShow(false);
                      setTime(times);
                    }}
                  >
                    Done
                  </button>
                </div>
              )}
            />
          </div>
        </>
      )}
    </div>
  );
}
